export default __webpack_public_path__ + "static/media/mobile3.9d629589.jfif";